export const TAGS_LOAD = 'TAGS_LOAD';
export const TAG_CREATE = 'TAG_CREATE';
export const TAG_UPDATE = 'TAG_UPDATE';
export const TAG_DELETE = 'TAG_DELETE';
